import { CallEnd as CallEndIcon } from '@mui/icons-material'
import { ControlButton } from './control-button'
import { callService } from '$logic/call'
import { t } from '$i18n'

export function OutgoingCallControls() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <ControlButton
        color="error"
        caption={t('call.cancel')}
        icon={<CallEndIcon />}
        onClick={callService.cancelOutgoingCall}
      />
    </div>
  )
}
